import React from "react";
import { Footer } from "./html/Footer";
import Header from "./html/Header";
import { getMessage } from "../../utils/getMessage";
import { getImage } from "../../utils/getImage";

export const SentComponent = ({ icon, icon2, msj }) => {
  return (
    <>
      <form className="rating" id="formSurvey">
        <div className="containerMessage sentContainer">
        <div className="separatorBlue"></div>
          {icon && <img className="sent-img1" src={icon} alt="" />}
          {icon2 && <img src={icon2} alt="" />}
          {/* <p>☻</p> */}
          {msj && <h1 className="sent-msj" dangerouslySetInnerHTML={{ __html: msj } } />}
        </div>
      </form>
      {/* <Footer  img1={getImage(4)} msg={getMessage(19)} /> */}
    </>
  );
};

